(function() {
    'use strict';

    angular
      .module('sempraWebapp')
      .filter('karcherOperationCountersTranslation', karcherOperationCountersTranslation);

    /** @ngInject */
    function karcherOperationCountersTranslation($translate) {
        return function(text) {
          if(!text) return;
          switch (text) {
            case "Washing%20station%201%20HP%20pump":
              return $translate.instant("KARCHER_OPERATION_COUNTER_1");
            case "Washing%20station%201%20chemical%20pump%201":
              return $translate.instant("KARCHER_OPERATION_COUNTER_2");
            case "Washing%20station%201%20chemical%20pump%202":
              return $translate.instant("KARCHER_OPERATION_COUNTER_3");
            case "Washing%20station%201%20chemical%20pump%203":
              return $translate.instant("KARCHER_OPERATION_COUNTER_4");
            case "Washing%20station%201%20chemical%20pump%204":
              return $translate.instant("KARCHER_OPERATION_COUNTER_5");
            case "Washing%20station%202%20HP%20pump":
              return $translate.instant("KARCHER_OPERATION_COUNTER_6");
            case "Washing%20station%202%20chemical%20pump%201":
              return $translate.instant("KARCHER_OPERATION_COUNTER_7");
            case "Washing%20station%202%20chemical%20pump%202":
              return $translate.instant("KARCHER_OPERATION_COUNTER_8");
            case "Washing%20station%202%20chemical%20pump%203":
              return $translate.instant("KARCHER_OPERATION_COUNTER_9");
            case "Washing%20station%202%20chemical%20pump%204":
              return $translate.instant("KARCHER_OPERATION_COUNTER_10");
            case "Washing%20station%203%20HP%20pump":
              return $translate.instant("KARCHER_OPERATION_COUNTER_11");
            case "Washing%20station%203%20chemical%20pump%201":
              return $translate.instant("KARCHER_OPERATION_COUNTER_12");
            case "Washing%20station%203%20chemical%20pump%202":
              return $translate.instant("KARCHER_OPERATION_COUNTER_13");
            case "Washing%20station%203%20chemical%20pump%203":
              return $translate.instant("KARCHER_OPERATION_COUNTER_14");
            case "Washing%20station%203%20chemical%20pump%204":
              return $translate.instant("KARCHER_OPERATION_COUNTER_15");
            case "Washing%20station%204%20HP%20pump":
              return $translate.instant("KARCHER_OPERATION_COUNTER_16");
            case "Washing%20station%204%20chemical%20pump%201":
              return $translate.instant("KARCHER_OPERATION_COUNTER_17");
            case "Washing%20station%204%20chemical%20pump%202":
              return $translate.instant("KARCHER_OPERATION_COUNTER_18");
            case "Washing%20station%204%20chemical%20pump%203":
              return $translate.instant("KARCHER_OPERATION_COUNTER_19");
            case "Washing%20station%204%20chemical%20pump%204":
              return $translate.instant("KARCHER_OPERATION_COUNTER_20");
            case "Washing%20station%205%20HP%20pump":
              return $translate.instant("KARCHER_OPERATION_COUNTER_21");
            case "Washing%20station%205%20chemical%20pump%201":
              return $translate.instant("KARCHER_OPERATION_COUNTER_22");
            case "Washing%20station%205%20chemical%20pump%202":
              return $translate.instant("KARCHER_OPERATION_COUNTER_23");
            case "Washing%20station%205%20chemical%20pump%203":
              return $translate.instant("KARCHER_OPERATION_COUNTER_24");
            case "Washing%20station%205%20chemical%20pump%204":
              return $translate.instant("KARCHER_OPERATION_COUNTER_25");
            case "Washing%20station%206%20HP%20pump":
              return $translate.instant("KARCHER_OPERATION_COUNTER_26");
            case "Washing%20station%206%20chemical%20pump%201":
              return $translate.instant("KARCHER_OPERATION_COUNTER_27");
            case "Washing%20station%206%20chemical%20pump%202":
              return $translate.instant("KARCHER_OPERATION_COUNTER_28");
            case "Washing%20station%206%20chemical%20pump%203":
              return $translate.instant("KARCHER_OPERATION_COUNTER_29");
            case "Washing%20station%206%20chemical%20pump%204":
              return $translate.instant("KARCHER_OPERATION_COUNTER_30");
            case "Washing%20station%207%20HP%20pump":
              return $translate.instant("KARCHER_OPERATION_COUNTER_31");
            case "Washing%20station%207%20chemical%20pump%201":
              return $translate.instant("KARCHER_OPERATION_COUNTER_32");
            case "Washing%20station%207%20chemical%20pump%202":
              return $translate.instant("KARCHER_OPERATION_COUNTER_33");
            case "Washing%20station%207%20chemical%20pump%203":
              return $translate.instant("KARCHER_OPERATION_COUNTER_34");
            case "Washing%20station%207%20chemical%20pump%204":
              return $translate.instant("KARCHER_OPERATION_COUNTER_35");
            case "Washing%20station%208%20HP%20pump":
              return $translate.instant("KARCHER_OPERATION_COUNTER_36");
            case "Washing%20station%208%20chemical%20pump%201":
              return $translate.instant("KARCHER_OPERATION_COUNTER_37");
            case "Washing%20station%208%20chemical%20pump%202":
              return $translate.instant("KARCHER_OPERATION_COUNTER_38");
            case "Washing%20station%208%20chemical%20pump%203":
              return $translate.instant("KARCHER_OPERATION_COUNTER_39");
            case "Washing%20station%208%20chemical%20pump%204":
              return $translate.instant("KARCHER_OPERATION_COUNTER_40");
            case "Osmosis%20pump":
              return $translate.instant("KARCHER_OPERATION_COUNTER_41");
            case "Hot%20water%20generator":
              return $translate.instant("KARCHER_OPERATION_COUNTER_42");
            case "Frost%20protection%20pump":
              return $translate.instant("KARCHER_OPERATION_COUNTER_43");
            case "WSO%20filter%20inlay":
              return $translate.instant("KARCHER_OPERATION_COUNTER_44");
            case "Washing%20station%20heater%20pump":
              return $translate.instant("KARCHER_OPERATION_COUNTER_45");
            case "Hot%20water%20pump":
              return $translate.instant("KARCHER_OPERATION_COUNTER_46");
            case "Foam%20hose%20heating":
              return $translate.instant("KARCHER_OPERATION_COUNTER_47");
            case "Wheel%20cleaning%20pump":
              return $translate.instant("KARCHER_OPERATION_COUNTER_48");
            case "Micro-emulsion%20pump":
              return $translate.instant("KARCHER_OPERATION_COUNTER_49");
            case "Intensive%20foam%20pump":
              return $translate.instant("KARCHER_OPERATION_COUNTER_50");
            case "Vacuum%20cleaner%201%20turbine%201":
              return $translate.instant("KARCHER_OPERATION_COUNTER_51");
            case "Vacuum%20cleaner%201%20filter%201":
              return $translate.instant("KARCHER_OPERATION_COUNTER_52");
            case "Vacuum%20cleaner%201%20turbine%202":
              return $translate.instant("KARCHER_OPERATION_COUNTER_53");
            case "Vacuum%20cleaner%201%20filter%202":
              return $translate.instant("KARCHER_OPERATION_COUNTER_54");
            case "Vacuum%20cleaner%202%20turbine%201":
              return $translate.instant("KARCHER_OPERATION_COUNTER_55");
            case "Vacuum%20cleaner%202%20filter%201":
              return $translate.instant("KARCHER_OPERATION_COUNTER_56");
            case "Vacuum%20cleaner%202%20turbine%202":
              return $translate.instant("KARCHER_OPERATION_COUNTER_57");
            case "Vacuum%20cleaner%202%20filter%202":
              return $translate.instant("KARCHER_OPERATION_COUNTER_58");
            case "Vacuum%20cleaner%203%20turbine%201":
              return $translate.instant("KARCHER_OPERATION_COUNTER_59");
            case "Vacuum%20cleaner%203%20filter%201":
              return $translate.instant("KARCHER_OPERATION_COUNTER_60");
            case "Vacuum%20cleaner%203%20turbine%202":
              return $translate.instant("KARCHER_OPERATION_COUNTER_61");
            case "Vacuum%20cleaner%203%20filter%202":
              return $translate.instant("KARCHER_OPERATION_COUNTER_62");
            case "Vacuum%20cleaner%204%20turbine%201":
              return $translate.instant("KARCHER_OPERATION_COUNTER_63");
            case "Vacuum%20cleaner%204%20filter%201":
              return $translate.instant("KARCHER_OPERATION_COUNTER_64");
            case "Vacuum%20cleaner%204%20turbine%202":
              return $translate.instant("KARCHER_OPERATION_COUNTER_65");
            case "Vacuum%20cleaner%204%20filter%202":
              return $translate.instant("KARCHER_OPERATION_COUNTER_66");
            case "Vacuum%20cleaner%205%20turbine%201":
              return $translate.instant("KARCHER_OPERATION_COUNTER_67");
            case "Vacuum%20cleaner%205%20filter%201":
              return $translate.instant("KARCHER_OPERATION_COUNTER_68");
            case "Vacuum%20cleaner%205%20turbine%202":
              return $translate.instant("KARCHER_OPERATION_COUNTER_69");
            case "Vacuum%20cleaner%205%20filter%202":
              return $translate.instant("KARCHER_OPERATION_COUNTER_70");
            case "Vacuum%20cleaner%206%20turbine%201":
              return $translate.instant("KARCHER_OPERATION_COUNTER_71");
            case "Vacuum%20cleaner%206%20filter%201":
              return $translate.instant("KARCHER_OPERATION_COUNTER_72");
            case "Vacuum%20cleaner%206%20turbine%202":
              return $translate.instant("KARCHER_OPERATION_COUNTER_73");
            case "Vacuum%20cleaner%206%20filter%202":
              return $translate.instant("KARCHER_OPERATION_COUNTER_74");
            case "Drain%20condensation%20water%20from%20the%20compressor":
              return $translate.instant("KARCHER_OPERATION_COUNTER_75");
            case "Check%20frost%20protection%20system":
              return $translate.instant("KARCHER_OPERATION_COUNTER_76");
            case "Burner%20fan":
              return $translate.instant("KARCHER_OPERATION_COUNTER_77");
            case "Booster%20pump%20foam":
              return $translate.instant("KARCHER_OPERATION_COUNTER_78");
            default:
              return text;
          }
        };
    }
})();
